import { redactInteractionRequest, redactInteractionResponse, validateInteractionResponse } from './interactions.js';
/** The invocation was rejected before any native side effect or turn admission. */
export class AgentCommandRejectedError extends Error {
    constructor(message) { super(message); this.name = 'AgentCommandRejectedError'; }
}
export function validateCommandDirectory(commands) {
    const ids = new Set();
    const names = new Set();
    for (const command of commands) {
        if (!command.id || ids.has(command.id) || !/^[^\s/]+$/u.test(command.name) || names.has(command.name)
            || typeof command.description !== 'string' || !['command', 'skill', 'prompt'].includes(command.kind)
            || (command.inputHint !== undefined && typeof command.inputHint !== 'string')
            || (command.shortDescription !== undefined && typeof command.shortDescription !== 'string')
            || (command.documentation !== undefined && (typeof command.documentation !== 'string' || !command.documentation.trim())))
            throw new Error('Invalid native command directory.');
        ids.add(command.id);
        names.add(command.name);
    }
    return commands.map((command) => ({ ...command }));
}
/** Command menus share the same response validation and events as native interactions. */
export class CommandInteractions {
    provider;
    emit;
    requests = new Map();
    prefix = `${Date.now().toString(36)}:${Math.random().toString(36).slice(2)}`;
    sequence = 0;
    constructor(provider, emit) {
        this.provider = provider;
        this.emit = emit;
    }
    get pending() { return this.requests.size > 0; }
    pendingInteractions() { return [...this.requests.values()].map(value => redactInteractionRequest(value.request)); }
    open(request, handler) {
        const requestId = `command:${this.prefix}:${++this.sequence}`;
        const full = { ...JSON.parse(JSON.stringify(request)), requestId };
        this.requests.set(requestId, { request: full, handler, submitting: false });
        this.emit({ type: 'interaction_requested', provider: this.provider, request: redactInteractionRequest(full) });
        return requestId;
    }
    async respond(requestId, response) {
        const pending = this.requests.get(requestId);
        if (!pending)
            return false;
        if (pending.submitting)
            throw new Error('Command interaction response is already pending.');
        validateInteractionResponse(pending.request, response);
        pending.submitting = true;
        try {
            const canceled = response.kind === 'question' ? response.dismissed === true
                : response.kind === 'form' && response.action !== 'submit';
            if (!canceled)
                await pending.handler(response);
            if (this.requests.get(requestId) === pending) {
                this.requests.delete(requestId);
                this.emit({ type: 'interaction_resolved', provider: this.provider, requestId, response: redactInteractionResponse(pending.request, response) });
            }
            return true;
        }
        finally {
            pending.submitting = false;
        }
    }
    clear() { this.requests.clear(); }
}
//# sourceMappingURL=commands.js.map